
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M102.3 86.2c5.4 0 10.4 1.4 15.1 4.1 4.7 2.7 8.3 6.4 11 11 2.7 4.7 4.1 9.7 4.1 15.1v9.5c0 3-1.1 5.6-3.2 7.7-2.1 2.1-4.7 3.2-7.7 3.2H42.2c-3 0-5.6-1.1-7.7-3.2-2.1-2.1-3.2-4.7-3.2-7.7v-9.5c0-5.4 1.4-10.4 4.1-15.1 2.7-4.7 6.4-8.3 11-11 4.7-2.7 9.7-4.1 15.1-4.1h3.8c5.3 2.4 10.7 3.6 16.5 3.6 5.8 0 11.2-1.2 16.5-3.6h4zM82 79c-5.3 0-10.1-1.3-14.5-3.8-4.4-2.6-7.9-6.1-10.5-10.5-2.6-4.4-3.8-9.3-3.8-14.5 0-5.2 1.3-10.1 3.8-14.5 2.6-4.4 6-7.9 10.5-10.5 4.4-2.6 9.3-3.8 14.5-3.8 5.2 0 10.1 1.3 14.5 3.8 4.4 2.6 7.9 6.1 10.5 10.5 2.6 4.4 3.8 9.3 3.8 14.5 0 5.2-1.3 10.1-3.8 14.5-2.6 4.4-6 7.9-10.5 10.5C92.1 77.7 87.3 79 82 79z"}})])
          )
        }
      }
    